import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
;;
import { Button, CardContent, Subtitle } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getUser, fetchLoggedInUser, finishOnboarding } from 'src/user';

function StepBegin({ fetchLoggedInUser, finishOnboarding, user }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const onClickStart = useCallback(() => {
    async function submit() {
      setLoading(true);

      await finishOnboarding(user.financialInstitutionId);
      if (user.isMerchantAdmin) {
        navigate('/business', { replace: true });
      } else {
        navigate('/people', { replace: true });
      }
    }
    submit();
  });

  useEffect(() => {
    async function load() {
      setLoading(true);

      await fetchLoggedInUser();

      setLoading(false);
    }
    load();
  }, []);

  return (
    <CardContent className="step-begin">
      <div className="has-text-centered has-icon-gradient-bright">
        <FontAwesomeIcon icon={['fal', 'check-circle']} size="6x" />
      </div>
      <Subtitle isSize="3" hasTextAlign="centered" hasTextColor="primary">
        Success! Let&apos;s Get Started.
      </Subtitle>
      <div className="buttons is-centered">
        <Button
          isColor="gradient-bright"
          isLoading={loading}
          disabled={loading}
          onClick={onClickStart}
        >
          Get Started
        </Button>
      </div>
    </CardContent>
  );
}

StepBegin.propTypes = {
  finishOnboarding: propTypes.func.isRequired,
  fetchLoggedInUser: propTypes.func.isRequired,
  user: propTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

const connectedStepBegin = connect(mapStateToProps, {
  fetchLoggedInUser,
  finishOnboarding,
})(StepBegin);

export { connectedStepBegin as StepBegin };
